export default __webpack_public_path__ + "static/media/Fl2.4436072c.jpg";